import InfoIcon from '../../assets/icons/InfoIcon.svg';
import PepperLogo from '../../assets/images/PepperLogo.svg';
import QuitIcon from '../../assets/icons/QuitIcon.svg';
import ReturnIcon from '../../assets/icons/ReturnIcon.svg';
import { Button, Divider, Modal, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../redux/modalSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES_PATH } from '../../utils/constants';
import { IRootState } from '../../redux/store';
import { clearBank } from '../../redux/providerSlice';
import { resettingLogin } from '../../redux/loginSlice';
import { isLoading } from '../../redux/loaderSlice';
import { defaultBankMode } from '../../redux/requestSlice';

export const Header: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userLogged = useSelector((state: IRootState) => state.login.value.credentials);

  const informationBox = () => {
    return (
      <div className="tooltip-info">
        <div className="pepper-title">Te informamos de que...</div>
        <div className="tooltip-text">En Pepper recibiremos la información básica de tu banca online y se procesará digitalmente por un robot para poder darte una respuesta inmediata a tu solicitud de financiación.
          Recuerda que tus datos están protegidos en todo momento. </div>
      </div>
    )
  }

  const selectLeftButton = () => {
    if (location.pathname === ROUTES_PATH.LOGIN) {
      return (
        <Button className='return-button' onClick={loginReturn}>
          <img src={ReturnIcon} />
        </Button>
      )
    } else {
      return (
        <Tooltip title={informationBox} placement="bottomLeft" color="white" trigger={['hover', 'click', 'focus']}>
          <img className='info-button' src={InfoIcon} />
        </Tooltip>
      )
    }
  }

  const loginReturn = () => {
    if (userLogged) {
      dispatch(isLoading(true));
      dispatch(resettingLogin(true))
    } else {
      if (process.env.REACT_APP_ENV === 'development') {
        navigate(ROUTES_PATH.ENTRY);
      } else {
        dispatch(clearBank());
        dispatch(defaultBankMode(false));
        navigate(ROUTES_PATH.ENTITIES);
      }
    }
  }


  return (
    <>
      <div className='pepper-header-container'>
        <div className='pepper-header-banner'>
          {selectLeftButton()}
          <img src={PepperLogo} />
          <Button className='quit-button' onClick={() => dispatch(showModal(true))}>
            <img src={QuitIcon} />
          </Button>
        </div>
        <Divider className='entry-separation-line' />
      </div>
    </>
  )
}